"use strict";
exports.__esModule = true;
exports.pluralizeWord = exports.toKebab = exports.toCamelCase = exports.stripHtmlTags = exports.joinStringsWithBullet = exports.replaceDashByBulletChar = exports.setenceWords = exports.capitaliseWords = exports.capitalize = void 0;
var BULLET_CHAR = "•";
var WHITE_SPACE_CHAR = " ";
var DASH_CHAR = "-";
function capitalize(string) {
    if (string === void 0) { string = ""; }
    if (!string) {
        return "";
    }
    return string.charAt(0).toUpperCase() + string.slice(1);
}
exports.capitalize = capitalize;
function capitaliseWords(string, spaceChar) {
    if (string === void 0) { string = ""; }
    if (spaceChar === void 0) { spaceChar = WHITE_SPACE_CHAR; }
    if (!string) {
        return "";
    }
    return string
        .toLowerCase()
        .split(spaceChar)
        .map(capitalize)
        .join(WHITE_SPACE_CHAR);
}
exports.capitaliseWords = capitaliseWords;
function setenceWords(string, spaceChar) {
    if (string === void 0) { string = ""; }
    if (spaceChar === void 0) { spaceChar = WHITE_SPACE_CHAR; }
    if (!string) {
        return "";
    }
    return string
        .toLowerCase()
        .split(spaceChar)
        .map(function (word, index) { return (index > 0 ? word : capitalize(word)); })
        .join(WHITE_SPACE_CHAR);
}
exports.setenceWords = setenceWords;
function replaceDashByBulletChar(string) {
    var _a;
    if (string === void 0) { string = ""; }
    return (_a = string === null || string === void 0 ? void 0 : string.replace(DASH_CHAR, BULLET_CHAR)) !== null && _a !== void 0 ? _a : "";
}
exports.replaceDashByBulletChar = replaceDashByBulletChar;
function joinStringsWithBullet() {
    var _a;
    var strings = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        strings[_i] = arguments[_i];
    }
    return ((_a = strings === null || strings === void 0 ? void 0 : strings.filter(function (string) { return string !== ""; }).join("".concat(WHITE_SPACE_CHAR).concat(BULLET_CHAR).concat(WHITE_SPACE_CHAR))) !== null && _a !== void 0 ? _a : "");
}
exports.joinStringsWithBullet = joinStringsWithBullet;
function stripHtmlTags(string) {
    if (string === void 0) { string = ""; }
    if (!string) {
        return "";
    }
    return string.replace(/<\/?[^>]+(>|$)/g, "");
}
exports.stripHtmlTags = stripHtmlTags;
function toCamelCase(str) {
    if (str === void 0) { str = ""; }
    var words = str.split(/[_-]/);
    var camelCaseWords = words.map(function (word, index) {
        if (index === 0) {
            return word;
        }
        return word.charAt(0).toUpperCase() + word.slice(1);
    });
    return camelCaseWords.join("");
}
exports.toCamelCase = toCamelCase;
function toKebab(str) {
    if (str === void 0) { str = ""; }
    return str
        .match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g)
        .map(function (x) { return x.toLowerCase(); })
        .join("-");
}
exports.toKebab = toKebab;
function pluralizeWord(word, count) {
    return "".concat(word).concat(count === 1 ? '' : 's');
}
exports.pluralizeWord = pluralizeWord;
